import React from 'react';

import { SubmitHandler, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { updateHrisIntegrationResponse } from './actions/update-hris-integration-response';

import { UiButton } from '../ui/ui-button';

import { FormTextField } from '../widgets/react-hook-form-components/form-text-field';

type InputProps = {
  hrisIntegrationResponse?: HrisIntegrationResponse;
  org: Org;
  handlePrevious: () => void;
  handleClose: () => void;
};

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => ({
  actions: {
    updateHrisIntegrationResponse: (update: HrisIntegrationResponseUpdateRequest) =>
      dispatch(updateHrisIntegrationResponse(update)),
  },
});

export const HrisIntegrationResponseUnsupportedDetails = ({
  hrisIntegrationResponse,
  org,
  handlePrevious,
  handleClose,
}: InputProps) => {
  const { actions } = mapDispatchToProps(useDispatch());
  const { unsupportedIntegrationName } = hrisIntegrationResponse || {};

  const defaultValues = {
    unsupportedIntegrationName: unsupportedIntegrationName || '',
  };
  const {
    control,
    errors,
    formState: { isDirty, isValid },
    handleSubmit,
    watch,
  } = useForm({ mode: 'all', defaultValues });

  const unsupportedIntegrationNameWatch = watch('unsupportedIntegrationName');

  const onSubmit: SubmitHandler<typeof defaultValues> = ({
    unsupportedIntegrationName: unsupportedIntegrationNameValue,
  }) => {
    if (isDirty && hrisIntegrationResponse) {
      actions.updateHrisIntegrationResponse({
        ...hrisIntegrationResponse,
        orgId: org.org_id,
        unsupportedIntegrationName: unsupportedIntegrationNameValue || null,
        HrisIntegrationType: null,
      });
    }

    handleClose();
  };

  const integrationNameRule = {
    value: 30,
    message: 'Max length exceeded',
  };

  const getSmartlookClickInfo = (action: string) => ({
    eventName: 'HRIS response dialog click',
    props: {
      component: 'unsupported details',
      integrationName: unsupportedIntegrationNameWatch,
      action,
    },
  });

  return (
    <>
      <div className="u-margin-top">
        At this time, your selection is not on the list of supported systems. Please share your
        HR/payroll system below, as we are always exploring new integrations
      </div>
      <FormTextField
        control={control}
        name="unsupportedIntegrationName"
        error={errors.unsupportedIntegrationName}
        label="HR/Payroll System"
        required
        maxLength={integrationNameRule}
      />
      <div className="u-flex-center u-margin-top u-justifyContent-spaceBetween">
        <UiButton
          variant="tertiary"
          size="sm"
          onClick={handlePrevious}
          smartlookEvent={getSmartlookClickInfo('previous')}
        >
          Previous
        </UiButton>
        <UiButton
          type="submit"
          variant="primary"
          size="sm"
          onClick={handleSubmit(onSubmit)}
          disabled={!isValid}
          smartlookEvent={getSmartlookClickInfo('save')}
        >
          Save
        </UiButton>
      </div>
    </>
  );
};
